import React, { Component } from "react";
import AppContext from "../../../contexts/AppContext";

class CreateModel extends Component {
    constructor(props) {
        super(props);
        this.state = {
            item: {},
            errors: {}
        };
    }

    create = e => {
        e.preventDefault();
        this.props
            .create(this.state.item)
            .then(response => {
                this.props.hideCreate();
            })
            .catch(errors => {
                switch (errors.response.status) {
                    case 422:
                        this.setState({ errors: errors.response.data.error });
                        break;
                    default:
                        this.context.state.handelError(errors);
                        break;
                }
            });
    };

    onChange(field) {
        let temp = this.state.item;
        temp[field.target.name] = field.target.value;

        let error = this.state.errors;
        error[field.target.name] = null;

        this.setState({ item: temp, errors: error });
    }

    render() {
        return (
            <div className="model-container model-center model-backdrop-show">
                <div
                    aria-labelledby="model-title"
                    aria-describedby="model-content"
                    className="model-popup model-modal model-show"
                    role="dialog"
                    aria-live="assertive"
                    aria-modal="true"
                >
                    <h2 className="mb-5">Create record</h2>
                    <div className="model-content">
                        <form onSubmit={this.create}>
                            <div className="form-group">
                                <label htmlFor="name">Name</label>
                                <input
                                    onChange={this.onChange.bind(this)}
                                    type="text"
                                    className="form-control"
                                    id="name"
                                    name="name"
                                    placeholder="Enter name"
                                ></input>
                                {this.state.errors.name ? (
                                    <div className="invalid-feedback">
                                        {this.state.errors.name}
                                    </div>
                                ) : null}
                            </div>
                            <div className="form-group">
                                <label htmlFor="price">Price</label>
                                <input
                                    onChange={this.onChange.bind(this)}
                                    type="text"
                                    className="form-control"
                                    id="price"
                                    name="price"
                                    placeholder="Enter price"
                                ></input>
                                {this.state.errors.price ? (
                                    <div className="invalid-feedback">
                                        {this.state.errors.price}
                                    </div>
                                ) : null}
                            </div>
                            <div className="form-group">
                                <label htmlFor="articles">Articles</label>
                                <input
                                    onChange={this.onChange.bind(this)}
                                    type="text"
                                    className="form-control"
                                    id="articles"
                                    name="articles"
                                    placeholder="Enter articles"
                                ></input>
                                {this.state.errors.articles ? (
                                    <div className="invalid-feedback">
                                        {this.state.errors.articles}
                                    </div>
                                ) : null}
                            </div>
                            <div className="form-group">
                                <label htmlFor="jobs">Jobs</label>
                                <input
                                    onChange={this.onChange.bind(this)}
                                    type="text"
                                    className="form-control"
                                    id="jobs"
                                    name="jobs"
                                    placeholder="Enter jobs"
                                ></input>
                                {this.state.errors.jobs ? (
                                    <div className="invalid-feedback">
                                        {this.state.errors.jobs}
                                    </div>
                                ) : null}
                            </div>

                            <div className="form-group">
                                <label htmlFor="description">Description</label>
                                <textarea
                                    onChange={this.onChange.bind(this)}
                                    className="form-control"
                                    placeholder="Description"
                                    name="description"
                                    rows="3"
                                ></textarea>
                                {this.state.errors.description ? (
                                    <div className="invalid-feedback">
                                        {this.state.errors.description}
                                    </div>
                                ) : null}
                            </div>
                            <div className="form-group">
                                <label htmlFor="main">Main</label>
                                <select
                                    onChange={this.onChange.bind(this)}
                                    type="text"
                                    className="form-control"
                                    id="main"
                                    name="main"
                                >
                                    <option>Select option</option>
                                    <option value="true">Yes</option>
                                    <option value="false">No</option>
                                </select>
                                {this.state.errors.main ? (
                                    <div className="invalid-feedback">
                                        {this.state.errors.main}
                                    </div>
                                ) : null}
                            </div>
                            <button
                                type="button"
                                onClick={this.create}
                                className="btn btn-primary mr-2"
                            >
                                Submit
                            </button>
                            <button
                                type="button"
                                onClick={this.props.hideCreate}
                                className="btn btn-default"
                            >
                                Cancel
                            </button>
                        </form>
                    </div>
                </div>
            </div>
        );
    }
}
CreateModel.contextType = AppContext;
export default CreateModel;



// WEBPACK FOOTER //
// ./src/components/admin/writerPlans/CreateModel.js